import { API_ENDPOINT } from '../constants';
import { HTTP } from './http.service';

// Alineado con raptor-cpd/src/modules/audit/domain (AuditLogPublic) y dto/audit.schemas.ts
export interface AuditActor {
  id: string;
  email?: string;
  username?: string;
  roles: string[];
}

export interface AuditContext {
  path: string;
  method: string;
  ip?: string;
  userAgent?: string;
}

export interface AuditLog {
  id: string;
  at: string;
  actor: AuditActor;
  action: string;
  entityType: string;
  entityId?: string;
  before?: Record<string, unknown>;
  after?: Record<string, unknown>;
  metadata?: Record<string, unknown>;
  context: AuditContext;
  success: boolean;
  errorMessage?: string;
}

export interface AuditList {
  items: AuditLog[];
  total: number;
  limit: number;
  offset: number;
}

export interface AuditQuery {
  entityType?: string;
  entityId?: string;
  actorId?: string;
  action?: string;
  success?: boolean;
  /** YYYY-MM-DD */
  from?: string;
  to?: string;
  /** 1..500 default 50 */
  limit?: number;
  offset?: number;
}

/** Valores que hoy emite el backend con @Audit() (para los selects de filtro). */
export const AUDIT_ENTITY_TYPES = [
  'auth',
  'user',
  'cpd_template',
  'cpd_operator',
  'cpd_route',
  'cpd_route_operator'
] as const;
export const AUDIT_ACTIONS = [
  'login',
  'logout',
  'password_change',
  'password_reset_request',
  'password_reset_consume',
  'create',
  'update',
  'delete',
  'reload'
] as const;

const clean = <T extends object>(q: T): Partial<T> =>
  Object.fromEntries(
    Object.entries(q).filter(([, v]) => v !== undefined && v !== null && v !== '')
  ) as Partial<T>;

/** GET /v1/audit — solo admin/superadmin. TTL del log en el backend: 365 días. */
export const AuditService = {
  search: (params: AuditQuery) =>
    HTTP.get<AuditList, AuditList>(`${API_ENDPOINT.CORE}audit`, { params: clean(params) })
};
